import { render, staticRenderFns } from "./CreateSubColorDialog.vue?vue&type=template&id=73752f18&scoped=true"
import script from "@/views/Settings/Colors/CreateSubColorDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Colors/CreateSubColorDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Colors/create-subcolor-dialog.scss?vue&type=style&index=0&id=73752f18&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73752f18",
  null
  
)

export default component.exports